import React, { Fragment } from "react";
import Contentify from "../../content/Contentify";
import Store from "./../../content/Store";
import Button from "./../shared/buttons/Button";
import { connect } from "react-redux";
import { setIframeSrc } from "./../../actions/makeAClaim/MakeAClaimActions";
import { Paths } from "./../../constants/UrlConstants";
import { withRouter } from "react-router-dom";
import {
  DentOptCash,
  DentOptCashPlus,
  PrivateGP
} from "../../constants/SMEModules";
import { shouldShowIfAllSMEModulesMatch } from "../../helpers/SMEModules/smeModuleHelper";
import IsNewClaimForCondition from "./IsNewClaimForCondition";
import {
  AUTHORISE_TREATMENT,
} from "./Constants";

export const GetStartedButton = ({
  content,
  action,
  preAuth,
  history,
  setIframeSrc, isInternational, claimType
}) => (
  <Fragment>
    {isInternational === true && claimType === AUTHORISE_TREATMENT && (
      <div className="hbsTop">
        <IsNewClaimForCondition />
      </div>)}
    <div className="hbsTop text-right">
      <Button
        label={content.label}
        onClick={() => {
          setIframeSrc(action, preAuth);
          history.push(Paths.StartClaim);
        }}
      />
    </div>
  </Fragment>
);

GetStartedButton.content = Store.GetStartedButton;

export const mapStateToGetStartedButton = ({
  makeAClaimReducer,
  policyReducer,
  claimType
}) => {
  let { isNewClaim, action, preAuth } = makeAClaimReducer;

  if (
    shouldShowIfAllSMEModulesMatch(policyReducer.selectedPolicy, [
      DentOptCash,
      DentOptCashPlus
    ])
  ) {
    action = "cashBenefitDental";
  } else if (
    shouldShowIfAllSMEModulesMatch(policyReducer.selectedPolicy, [PrivateGP])
  ) {
    action = "cashBenefitPrivateGP";
  }

  return {
    isNewClaim,
    action,
    preAuth,
    isInternational:
      policyReducer.selectedPolicy &&
      policyReducer.selectedPolicy.IsInternational,
    claimType: makeAClaimReducer.claimType
  };
};

export default withRouter(
  connect(mapStateToGetStartedButton, { setIframeSrc })(
    Contentify(GetStartedButton)
  )
);
